import { request } from '@services'
import { times } from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
import { GENDER } from '@/src/utils/constant'
import differenceInCalendarYears from 'date-fns/differenceInCalendarYears'
export const state = {
  loading: false,
  data: null,
  errors: null,
  overview: null,
  status: null,
}

export const getters = {
  getMemberListAgent(state) {
    const data = cloneDeep(state.data)
    if (data) {
      const list = data?.list?.map((item) => {
        item.photo = item.photo
          ? process.env.VUE_APP_API_BASE_URL + '/' + item.photo
          : ''
        item.gender = GENDER[item.gender]
        item.birthday = differenceInCalendarYears(
          new Date(),
          new Date(item.birthday)
        )
        item.BMI = item.BMI ? parseFloat(item.BMI).toFixed(1) : ''
        item.weight = item.last_measure_data.weight
          ? parseFloat(item.last_measure_data.weight).toFixed(2) + 'kg'
          : ''
        item.body_fat_rate = item.last_measure_data.body_fat_rate
          ? parseFloat(item.last_measure_data.body_fat_rate).toFixed(1) + '%'
          : ''
        item.compare_weight = item.compare_weight
          ? parseFloat(item.compare_weight).toFixed(2) + 'kg'
          : ''
        item.compare_BodyFatRate = item.compare_BodyFatRate
          ? parseFloat(item.compare_BodyFatRate).toFixed(1) + '%'
          : ''
        item.admin_note = item.admin_note ? item.admin_note : '-'
        item.master_member_id = !item.master_member_id
        item.BMR = item.last_measure_data.BMR
          ? parseFloat(item.last_measure_data.BMR).toFixed(0) + 'kcal'
          : ''
        item.body_water_rate = item.last_measure_data.body_water_rate
          ? parseFloat(item.last_measure_data.body_water_rate).toFixed(1) + '%'
          : ''
        item.bone_mass = item.last_measure_data.bone_mass
          ? parseFloat(item.last_measure_data.bone_mass).toFixed(2) + 'kg'
          : ''
        item.lean_body_weight = item.last_measure_data.lean_body_weight
          ? parseFloat(item.last_measure_data.lean_body_weight).toFixed(2) +
            'kg'
          : ''
        item.metabolic_age = item.last_measure_data.metabolic_age
          ? parseFloat(item.last_measure_data.metabolic_age).toFixed(0)
          : ''
        item.muscle_mass = item.last_measure_data.muscle_mass
          ? parseFloat(item.last_measure_data.muscle_mass).toFixed(2) + 'kg'
          : ''
        item.muscle_rate = item.last_measure_data.muscle_rate
          ? parseFloat(item.last_measure_data.muscle_rate).toFixed(1) + '%'
          : ''
        item.protein = item.last_measure_data.protein
          ? parseFloat(item.last_measure_data.protein).toFixed(2) + '%'
          : ''
        item.subcutaneous_fat = item.last_measure_data.subcutaneous_fat
          ? parseFloat(item.last_measure_data.subcutaneous_fat).toFixed(1) + '%'
          : ''
        item.visceral_fat = item.last_measure_data.visceral_fat
          ? parseFloat(item.last_measure_data.visceral_fat).toFixed(0)
          : ''

        item.body_fat_rate_range = item.last_measure_data.body_fat_rate_range
          ? item.last_measure_data.body_fat_rate_range
          : ''
        item.BMR_range = item.last_measure_data.BMR_range
          ? item.last_measure_data.BMR_range
          : ''
        item.BMI_range = item.last_measure_data.BMI_range
          ? item.last_measure_data.BMI_range
          : ''
        item.body_water_rate_range = item.last_measure_data
          .body_water_rate_range
          ? item.last_measure_data.body_water_rate_range
          : ''
        item.bone_mass_range = item.last_measure_data.bone_mass_range
          ? item.last_measure_data.bone_mass_range
          : ''
        item.metabolic_age_range = item.last_measure_data.metabolic_age_range
          ? item.last_measure_data.metabolic_age_range
          : ''
        item.muscle_mass_range = item.last_measure_data.muscle_mass_range
          ? item.last_measure_data.muscle_mass_range
          : ''
        item.muscle_rate_range = item.last_measure_data.muscle_rate_range
          ? item.last_measure_data.muscle_rate_range
          : ''
        item.protein_range = item.last_measure_data.protein_range
          ? item.last_measure_data.muscle_mass_range
          : ''
        item.subcutaneous_fat_range = item.last_measure_data
          .subcutaneous_fat_range
          ? item.last_measure_data.subcutaneous_fat_range
          : ''
        item.visceral_fat_range = item.last_measure_data.visceral_fat_range
          ? item.last_measure_data.visceral_fat_range
          : ''
        item.weight_range = item.last_measure_data.weight_range
          ? item.last_measure_data.weight_range
          : ''
        return item
      })
      data.list = list
    }
    return data
  },
  getOverviewMember(state) {
    if (state.overview && state.status) {
      const data = cloneDeep(state.overview)
      const arr = [
        parseInt(data.status1_ratio),
        parseInt(data.status2_ratio),
        parseInt(data.status3_ratio),
        parseInt(data.status4_ratio),
        parseInt(data.status5_ratio),
        parseInt(data.status6_ratio),
        parseInt(data.status7_ratio),
        parseInt(data.status8_ratio),
      ]

      const total = arr.reduce(
        (accumulator, currentValue) => accumulator + currentValue
      )
      const status = []
      const age = []

      times(8, String).forEach((e, index) => {
        status.push({
          indexStatus: index + 1,
          label: state.status[`status${index + 1}_name`],
          value: data[`status${index + 1}_ratio`]
            ? data[`status${index + 1}_ratio`]
            : 0,
          color: 'status',
        })
      })

      status.push({
        indexStatus: 9,
        label: '未設定',
        value: 100 - total,
        color: 'status',
      })

      times(5, String).forEach((e, index) => {
        age.push({
          age: (index + 1) * 10,
          label: index + 1 + '0代',
          value: data[`age_${index + 1}0s_ratio`]
            ? data[`age_${index + 1}0s_ratio`]
            : 0,
          color: 'primary',
        })
      })

      age.push({
        age: 0,
        label: 'その他',
        value: data.age_other_ratio ? data.age_other_ratio : 0,
        color: 'primary',
      })

      const overview = [
        {
          key: '男女比',
          value: [
            {
              label: '男性',
              value: data.men_ratio ? data.men_ratio : 0,
              color: 'men',
            },
            {
              label: '女性',
              value: data.women_ratio ? data.women_ratio : 0,
              color: 'woman',
            },
          ],
        },
        {
          key: 'ステータス比',
          value: status,
        },
        {
          key: '年代比',
          value: age,
        },
      ]
      return overview
    }
    return []
  },
}

export const mutations = {
  SET_STATUS(state, newData) {
    state.status = newData
  },
  SET_MEMBER_OVERVIEW(state, newData) {
    state.overview = newData
  },
  SET_MEMBER_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_MEMBER_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_MEMBER_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.data = null
    state.errors = error
  },
  RESET_MEMBER_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingMemberListAgent({ commit }, params) {
    commit('SET_MEMBER_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/list_agent/',
        payload: { ...params },
      })
      commit('SET_MEMBER_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEMBER_LIST_RECEIVED_FAILED', error)
    }
  },
  resetMemberList({ commit }) {
    commit('RESET_MEMBER_LIST')
  },
  async exportMemberCsv({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/export/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async fetchingOverviewMember({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/overview/',
        payload: { ...params },
      })
      commit('SET_MEMBER_OVERVIEW', response.data[0])
      return response.data[0]
    } catch (error) {
      return error
    }
  },
  async fetchingChartData({ commit }, params) {
    try {
      const response = await request({
        endpoint: 'cms/member/charts/register/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async exportMemberListAgentCsv({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/export_agent/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async fetchingStatus({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/agent/get/',
        payload: { ...params },
      })
      commit('SET_STATUS', response)
      return response
    } catch (error) {
      return error
    }
  },
  async changeStatusMember({ commit }, params) {
    try {
      const response = await request({
        endpoint: 'cms/member/status_apply/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async unbindMember({ commit }, params) {
    try {
      const response = await request({
        endpoint: 'cms/member/unbind/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
